<template>
    <div class="modal">
        <div class="text">
            로그인을 해주세요.
        </div>
        <div class="close" @click="$emit('close')">
            닫기
        </div>
        <div class="confirm" @click="toLogin">
            로그인
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        toLogin() {
            location.href = '/sso/loginView.do';
        }
    }
}
</script>

<style scoped>
    @import url(./modal);
</style>


// WEBPACK FOOTER //
// src/components/jb/Modal.vue